'use strict';

var illustrations = {};

exports.__exports = illustrations;
//# sourceMappingURL=illustrations.cjs.map
